// Store
import { configureStore } from '@reduxjs/toolkit';

import {SUBSCRIPTION, CONFIGURATION, CHECKLIST} from '../Const';

type initState = {
    init:boolean, // init site flag
    step:number, // current step
    // To track how many steps completed (switching between steps manually)
    step_reached:number, 
    cloud:string, // redirect cloud 
    subscription:SUBSCRIPTION,
    checklist:CHECKLIST,
    configuration:CONFIGURATION,
    theme:any | null,
    error:string | null,
    // step 1 license start point (General - enter license, Subscription - validate email and generate license)
    license_start_point:string | null,
    redirected_from_marketplace: boolean,
    token:string | null,

}

const initialState:initState = {
    init:false,
    step:1,
    step_reached:1,
    cloud:'aws',
    checklist:{subscribed_controller:false,subscribed_copilot:false},
    subscription:{ license:'', sub_id:'', domain:'', email:'', plan_id:'' },
    configuration:{csp:'aws',region:'',ips:'', deploy_in:null},
    theme:'light',
    error:null,
    license_start_point:null,
    token:null,
    redirected_from_marketplace:false
}

const reducer = (state:initState = initialState, action:any) =>{
    let payload = action.payload;
    return {...state,...payload};
}

export default configureStore({
    reducer: reducer,
});